<nav id="accessibility" class="sr-only">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <ul class="nav nav-fill nav-accessibility">
          <li>
            <span class="label label-primary">1</span> <a href="#header" accesskey="1">Ir para o cabeçalho</a>
          </li>
          <li>
            <span class="label label-primary">2</span> <a href="#conteudo" accesskey="2">Ir para o conteúdo</a>
          </li>
          <li>
            <span class="label label-primary">3</span> <a href="#footer" accesskey="3">Ir para o rodapé</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>

<header id="header" class="container header">
  <div class="base-logos">
    <div class="logos">
      <div class="row justify-content-center">
        <div class="col text-center" style="max-width: 100%;">
          <img src="assets/header/logo.png" style="max-width: min(90vw,500px);"/>
        </div>
      </div> <!-- /row -->
    </div>
  </div>
</header>

<router-outlet>
</router-outlet>

<footer id="footer" class="footer">
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-8"><img src="assets/footer/pagmob.png" alt="Pagmob" style="max-height: 50px;" /></div>
      <div class="col-12 col-md-4 copyright">©2023 Pagmob<br /><small id="version"></small>
      </div>
    </div> <!-- /row -->
  </div>
</footer>
<simple-notifications></simple-notifications>
